"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const ModalWrapper = styled_components_1.default.div `
  [role='dialog'] {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    display: ${props => (props.isOpen ? 'block' : 'none')};
    overflow: hidden;

    > div {
      width: 50vw;
      margin: 10vh auto;
      background: #fff;
      padding: 2rem;
      outline: none;
      position: relative;
      text-align: left;
      z-index: 101;
    }
  }

  button.close-button {
    position: absolute;
    right: 10px;
    top: 0;
    padding: 5px;
    border: none;
    font-size: 150%;
    cursor: pointer;
  }
`;
const ModalOverlay = styled_components_1.default.div `
  background: rgba(0, 0, 0, 0.33);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  display: ${props => (props.isOpen ? 'block' : 'none')};
`;
/**
 * Primary UI component for user interaction
 */
const Modal = ({ isOpen = false, children }) => {
    return (react_1.default.createElement(ModalWrapper, { isOpen: isOpen },
        react_1.default.createElement("div", { role: "dialog", "aria-modal": isOpen, "data-testid": "modal" },
            react_1.default.createElement("div", null, children)),
        react_1.default.createElement(ModalOverlay, { isOpen: isOpen })));
};
exports.Modal = Modal;
//# sourceMappingURL=modal.js.map